<template>
  <div>
    <Input
      label="global.name"
      v-model="form.name"
      :defaultValue="selectedItem.name"
      :state="validateState('name')"
    />

    <b-form-group :label="$t('global.type')" :state="validateState('type')">
      <multiselect
        v-model="form.type"
        :options="typeList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('global.type')"
        :show-no-results="false"
      />
    </b-form-group>

    <Input
      label="iam.ldap_server_name"
      v-model="form.ldap_server_name"
      :defaultValue="selectedItem.ldap_server_name"
      placeholder="iam.ldap_server_name_placeholder"
      :state="validateState('ldap_server_name')"
    />

    <Input
      label="iam.ldap_server_url"
      v-model="form.ldap_server_url"
      :defaultValue="selectedItem.ldap_server_url"
      placeholder="iam.ldap_server_url_placeholder"
      :state="validateState('ldap_server_url')"
    />

    <Input
      label="iam.ldap_server_port"
      v-model="form.ldap_server_port"
      :defaultValue="selectedItem.ldap_server_port"
      placeholder="iam.ldap_server_port_placeholder"
      :state="validateState('ldap_server_port')"
    />

    <Input
      label="iam.ldap_base_dn"
      v-model="form.ldap_base_dn"
      :defaultValue="selectedItem.ldap_base_dn"
      placeholder="iam.ldap_base_dn_placeholder"
      :state="validateState('ldap_base_dn')"
    />

    <Input
      label="iam.ldap_bind_username"
      v-model="form.ldap_bind_username"
      :defaultValue="selectedItem.ldap_bind_username"
      placeholder="iam.ldap_bind_username_placeholder"
      :state="validateState('ldap_bind_username')"
    />

    <Input
      label="iam.ldap_bind_password"
      v-model="form.ldap_bind_password"
      :defaultValue="selectedItem.ldap_bind_password"
      :state="validateState('ldap_bind_password')"
      type="password"
    />

    <Input
      label="iam.default_filter"
      v-model="form.default_filter"
      :defaultValue="selectedItem.default_filter"
      placeholder="iam.default_filter_placeholder"
      :state="validateState('default_filter')"
    />

    <Input
      label="iam.default_memberof"
      v-model="form.default_memberof"
      :defaultValue="selectedItem.default_memberof"
    />

    <Input
      label="iam.default_group"
      v-model="form.default_group"
      :defaultValue="selectedItem.default_group"
    />

    <Input
      label="iam.default_userid_field"
      v-model="form.default_userid_field"
      :defaultValue="selectedItem.default_userid_field"
      placeholder="iam.default_userid_field_placeholder"
    />

    <Input
      label="iam.default_password_field"
      v-model="form.default_password_field"
      :defaultValue="selectedItem.default_password_field"
    />

    <Input
      label="iam.default_email_field"
      v-model="form.default_email_field"
      :defaultValue="selectedItem.default_email_field"
    />

    <Input
      label="iam.default_alias_field"
      v-model="form.default_alias_field"
      :defaultValue="selectedItem.default_alias_field"
      placeholder="iam.default_alias_field_placeholder"
    />

    <Input
      label="iam.default_first_name_field"
      v-model="form.default_first_name_field"
      :defaultValue="selectedItem.default_first_name_field"
    />

    <Input
      label="iam.default_last_name_field"
      v-model="form.default_last_name_field"
      :defaultValue="selectedItem.default_last_name_field"
      placeholder="iam.default_last_name_field_placeholder"
    />

    <b-form-group :label="$t('gateways.is_connected')">
      <multiselect
        v-model="form.is_connected"
        :options="booleanList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('gateways.is_connected')"
        :show-no-results="false"
      />
    </b-form-group>

    <b-form-group :label="$t('gateways.is_connection_secure')">
      <multiselect
        v-model="form.is_connection_secure"
        :options="booleanList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('gateways.is_connection_secure')"
        :show-no-results="false"
      />
    </b-form-group>

    <b-form-group :label="$t('gateways.is_usable')">
      <multiselect
        v-model="form.is_usable"
        :options="booleanList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('gateways.is_usable')"
        :show-no-results="false"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'ServiceForm',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedItem: String | Object,
  },
  data() {
    return {
      form: {
        name: '',
        type: '',
        ldap_server_name: '',
        ldap_server_url: '',
        ldap_server_port: '',
        ldap_base_dn: '',
        ldap_bind_username: '',
        ldap_bind_password: '',
        default_filter: '',
        default_memberof: '',
        default_group: '',
        default_userid_field: '',
        default_password_field: '',
        default_email_field: '',
        default_alias_field: '',
        default_first_name_field: '',
        default_last_name_field: '',
        is_connected: '',
        is_connection_secure: '',
        is_usable: '',
      },
      typeList: [
        { id: 'plusclouds-iam', name: 'plusclouds-iam' },
        { id: 'ldap', name: 'ldap' },
        { id: 'active-directory', name: 'active-directory' },
      ],
      booleanList: [
        { id: '1', name: this.$t('global.true') },
        { id: '0', name: this.$t('global.false') },
      ],
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      type: {
        required,
      },
      ldap_server_name: {
        required,
      },
      ldap_server_url: {
        required,
      },
      ldap_server_port: {
        required,
      },
      ldap_base_dn: {
        required,
      },
      ldap_bind_username: {
        required,
      },
      ldap_bind_password: {
        required: requiredIf(function () {
          return this.selectedItem == ''
        }),
      },
      default_filter: {
        required,
      },
    },
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        type: this.form.type.id,
        ldap_server_name: this.form.ldap_server_name,
        ldap_server_url: this.form.ldap_server_url,
        ldap_server_port: this.form.ldap_server_port,
        ldap_base_dn: this.form.ldap_base_dn,
        ldap_bind_username: this.form.ldap_bind_username,
        default_filter: this.form.default_filter,
      }

      if (this.form.ldap_bind_password)
        params.ldap_bind_password = this.form.ldap_bind_password
      if (this.form.default_memberof)
        params.default_memberof = this.form.default_memberof
      if (this.form.default_group)
        params.default_group = this.form.default_group
      if (this.form.default_userid_field)
        params.default_userid_field = this.form.default_userid_field
      if (this.form.default_password_field)
        params.default_password_field = this.form.default_password_field
      if (this.form.default_email_field)
        params.default_email_field = this.form.default_email_field
      if (this.form.default_alias_field)
        params.default_alias_field = this.form.default_alias_field
      if (this.form.default_first_name_field)
        params.default_first_name_field = this.form.default_first_name_field
      if (this.form.default_last_name_field)
        params.default_last_name_field = this.form.default_last_name_field
      if (this.form.is_connected)
        params.is_connected = this.form.is_connected.id
      if (this.form.is_connection_secure)
        params.is_connection_secure = this.form.is_connection_secure.id
      if (this.form.is_usable) params.is_usable = this.form.is_usable.id

      if (this.selectedItem == '') this.insertOperation(params)
      else this.updateOperation(params)
    },
    insertOperation(params) {
      ApiService.post(`iam`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    updateOperation(params) {
      ApiService.put(`iam/${this.selectedItem.id}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    selectedItem(newVal) {
      this.$v.$reset()
      this.form.type = ''
      this.form.is_connected = ''
      this.form.is_connection_secure = ''
      this.form.is_usable = ''

      if (newVal) {
        if (newVal.type != '')
          this.form.type = {
            id: newVal.type,
            name: newVal.type,
          }

        if (newVal.is_connected != '')
          this.form.is_connected = {
            id: newVal.is_connected,
            name: this.$t(
              newVal.is_connected == '1' ? 'global.true' : 'global.false'
            ),
          }

        if (newVal.is_connection_secure != '')
          this.form.is_connection_secure = {
            id: newVal.is_connection_secure,
            name: this.$t(
              newVal.is_connection_secure == '1'
                ? 'global.true'
                : 'global.false'
            ),
          }

        if (newVal.is_usable != '')
          this.form.is_usable = {
            id: newVal.is_usable,
            name: this.$t(
              newVal.is_usable == '1' ? 'global.true' : 'global.false'
            ),
          }
      }
    },
  },
}
</script>
